export default {
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		ProgramID: {
			class: 'value',
			dataName: 'ProgramID',
			type: 'string',
			title: 'Program ID',
			width: 100,
			hidden: false,
			readOnly: false,
		},
		Title: {
			class: 'value',
			dataName: 'Title',
			type: 'string',
			title: 'Program Name',
			width: 100,
			hidden: false,
			readOnly: false,
			//template:'<a href="/\\event/buyout/#:Id #">#:PartnerName #</a>'
		},
		InvestmentId: {
			class: "lookup",
			dataName: 'InvestmentId',
			type: 'number',
			title: 'Investment Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		InvestmentInvestmentID: {
			class: "lookup",
			dataName: 'Investment/InvestmentID',
			type: 'string',
			title: 'Investment ID',
			width: 100,
			hidden: false,
			readOnly: true
		},
		InvestmentTitle: {
			class: "lookup",
			dataName: 'Investment/Title',
			type: 'string',
			title: 'Investment Name',
			width: 100,
			hidden: false,
			readOnly: true
		},
        TaxYearQuarter: {
			class: "value",
			dataName: 'TaxYearQuarter',
			type: 'string',
			title: 'Period',
			width: 100,
			hidden: false,
			readOnly: true
		},
        ProjectedValue: {
			class: "value",
			dataName: 'ProjectedValue',
			type: 'number',
			title: 'Projected Value',
			template: '#=kendo.toString(ProjectedValue, "c")#',
			width: 100,
			hidden: false,
			readOnly: false
        },
        CurrentValue: {
			class: "value",
			dataName: 'CurrentValue',
			type: 'number',
			title: 'Current Value',
			template: '#=kendo.toString(CurrentValue, "c")#',
			width: 100,
			hidden: false,
			readOnly: false
        },
        AllocationStatus: {
			class: "value",
			dataName: 'AllocationStatus',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: false,
			readOnly: false
        },
        AllocationDate: {
			class: "value",
			dataName: 'AllocationDate',
			type: 'date',
			title: 'Date Updated',
			width: 100,
			hidden: false,
			readOnly: false
		}
        
	}
}